import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.sendTimeZoneToSettings()
  }

  sendTimeZoneToSettings () {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!userTimeZone) return

    fetch('/settings/profile', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getMetaValue('csrf-token')
      },
      body: JSON.stringify({
        profile: {
          timezone: userTimeZone
        }
      })
    }).catch(error => {
      console.error('Error sending timezone:', error)
    })
  }

  getMetaValue (name) {
    const element = document.querySelector(`meta[name="${name}"]`)
    return element && element.getAttribute('content')
  }
}
